import { CallGroupTypes } from '@frontend/api-call-group';

/**
 * Returns a unique, stable identifier for a device row within a call group's local
 * (possibly unsaved) device list.
 *
 * Devices that have just been assigned locally (via the assign device modal) but not
 * yet persisted via a save have an empty `callLegId`, since the backend hasn't generated
 * one yet. If multiple such devices exist at once, comparing by `callLegId` alone would
 * treat them all as the same device. This falls back to the device's underlying
 * deviceId / forwardingNumberId (which are always unique, even before saving) to
 * keep each row distinguishable.
 */
export const getDeviceKey = (device: CallGroupTypes.Device): string => {
  if (device.callLegId) {
    return device.callLegId;
  }
  if (device.deskPhone) {
    return `deskPhone:${device.deskPhone.deviceId}`;
  }
  if (device.softPhone) {
    return `softPhone:${device.softPhone.deviceId}`;
  }
  if (device.mobilePhone) {
    return `mobilePhone:${device.mobilePhone.deviceId}`;
  }
  if (device.forwardingNumber) {
    return `forwardingNumber:${device.forwardingNumber.forwardingNumberId}`;
  }
  return device.callLegId;
};
